import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  actions: {
    async addCreditEarnings ({ }, options) {
      let response = (await Vue.http.post(this.state.baseUrl + '/usercreditearning/add', options)).data
      return response
    },
    async getTotalEarnings ({ }, options) {
      let response = (await Vue.http.post(this.state.baseUrl + '/usercreditearning/totalearnings', options)).data
      return response
    },
    async getEarningsStats ({ }, options) {
      let response = (await Vue.http.post(this.state.baseUrl + '/usercreditearning/earningstats', options)).data
      return response
    },
  }
}
